import { CommunicationAlertEntity } from "./domain/communicationAlert.entity";
import { defineMessages } from "react-intl";
import { Message } from "../shared/i18n";
import { defaultFormMessages } from "../shared/crud/form";

const formMessages: Record<keyof CommunicationAlertEntity, Message> = defineMessages({
  id: {
    id: "communicationAlertForm.label.id",
    defaultMessage: "communicationAlert",
  },
  limiteAvisoDisponibilidad: {
    id: "communicationAlertForm.label.limiteAvisoDisponibilidad",
    defaultMessage: "limiteAvisoDisponibilidad",
  },
  emailAvisoDispo: {
    id: "communicationAlertForm.label.emailAvisoDispo",
    defaultMessage: "emailAvisoDispo",
  },
});

export const messages = {
  ...defaultFormMessages,
  ...formMessages,
  ...defineMessages({
    entityName: {
      id: "communicationAlert.entityName",
      defaultMessage: "Communication Alerts",
    },
    limiteAvisoDisponibilidadHelperText: {
      id: "communicationAlertForm.label.limiteAvisoDisponibilidadHelperText",
      defaultMessage: "limiteAvisoDisponibilidadHelperText",
    },
    emailAvisoDispoHelperText: {
      id: "communicationAlertForm.label.emailAvisoDispoHelperText",
      defaultMessage: "emailAvisoDispoHelperText",
    }
  }),
};
